module.exports = __webpack_public_path__ + "images/game/level-3.9173f57a2b243763bd50b3a21099585d.png";